<template>
  <v-form
    ref="tagForm"
    v-model="isFormValid"
    class="tag-form"
    @submit.prevent="submitForm"
  >
    <label class="input-label">Tekst</label>
    <v-text-field
      v-model="name"
      v-bind="validatedFieldProps"
      placeholder="Wprowadź tekst"
      :rules="[rules.required, rules.maxLength(50)]"
    />

    <v-btn
      class="custom-submit-button mt-4"
      color="primary"
      type="submit"
    >
      {{ tag ? 'Zapisz' : 'Stwórz' }}
    </v-btn>
  </v-form>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import props from '@/helpers/componentsProps';
import rules from '@/helpers/validators';

export default {
  props: {
    tag: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      validatedFieldProps: props.validatedField,
      rules,
      name: '',
      isFormValid: null,
    };
  },

  created() {
    if (this.tag) this.name = this.tag.name;
  },

  computed: {
    ...mapState('filters', [
      'filtersOptions',
    ]),
  },

  methods: {
    ...mapActions('tags', [
      'createTag',
      'updateTag',
    ]),
    ...mapActions('snackbar', [
      'showSnackbar',
    ]),
    ...mapActions('dialog', [
      'clearDialog',
    ]),

    showErrors(errors) {
      this.showSnackbar({
        message: errors,
        type: 'error',
      });
    },

    submitForm() {
      this.$refs.tagForm.validate();

      if (this.isFormValid) {
        const tag = { name: this.name };
        if (this.tag) {
          this.updateTag({ tag, id: this.tag.id }).then(() => this.clearDialog());
        } else {
          this.createTag(tag).then(() => this.clearDialog());
        }
      }
    },
  },

};
</script>
